<template>
    <v-container>
        <DlgMessage ref="dlgMsg" @dlgClose="dlgClose"></DlgMessage>
        <div class="mb-3">
          <v-toolbar>
            <v-btn icon class="hidden-xs-only" @click="$router.back()"><v-icon>mdi-arrow-left</v-icon></v-btn>
            <v-toolbar-title>{{ this.form.name }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-breadcrumbs :items="items"></v-breadcrumbs>
          </v-toolbar>
        </div> 
        <v-row class="mt-3">
           <v-col cols="12" md="12">
                <v-toolbar dark color="panel1"><v-toolbar-title>Info</v-toolbar-title>
            </v-toolbar>             
                <v-card class="mt-5">
                <v-form ref="mainForm">
                    <v-container class="py-0">
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-text-field v-model="form.sys_setting_id" disabled label="Rec Id" outlined></v-text-field>                                                                
                                <v-text-field v-model="form.name" readonly label="Name" :rules="inputRules" outlined></v-text-field>
                                <v-text-field v-model="form.key" readonly label="Key" :rules="inputRules" outlined></v-text-field>
                                <template v-if="form.type == 'html'">
                                    <v-toolbar dark color="panel2">
                                        <v-toolbar-title>Content</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-btn icon dark @click="save"><v-icon>save</v-icon></v-btn>
                                    </v-toolbar>             
                                    <v-card class="mt-5">
                                        <editor :content.sync="form.value"></editor>
                                    </v-card>
                                        

                                </template>
                                
                                <template v-if="form.type == 'json' && form.dimension == 'single'">
                                    <v-toolbar dark color="panel3">
                                        <v-toolbar-title>Setting Value</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-btn icon dark @click="save"><v-icon>save</v-icon></v-btn>
                                    </v-toolbar>             
                                    <v-card class="mt-5">
                                        <v-container class="py-0">
                                            <v-list>
                                                <v-list-item  v-for="(valueRec,index) in valueList" :key="index">
                                                    <InputField :inputName="index" :inputProp="inputProp" :content.sync="valueList[index]"></InputField>
                                                <!-- <v-text-field 
                                                    :label="index"
                                                    outlined 
                                                    v-model="valueList[index]" 
                                                ></v-text-field> -->
                                                </v-list-item>
                                            </v-list>
                                        </v-container>
                                    </v-card>

                                </template>

                                <template v-if="form.type == 'json' && form.dimension == 'multiple'">
                                    <v-toolbar dark color="panel3">
                                        <v-toolbar-title>Value</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-btn icon dark @click="save"><v-icon>save</v-icon></v-btn>
                                    </v-toolbar>             

                                        <v-list>
                                            <v-list-group v-for="(valueRec,index) in valueList" :key="'key'+index">
                                                
                                                <template v-slot:activator>
                                                    <v-list-item-title>{{valueList[index]['description']}}</v-list-item-title>
                                                </template>
                                                <!-- <v-list-item-icon>
                                                    <v-btn :disabled="index==0" small icon dark class="primary" @click="moveItem('up',index)">
                                                        <v-icon>mdi-arrow-up</v-icon>
                                                    </v-btn>
                                                    <v-btn :disabled="index==valueList.length-1" small icon dark class="primary" @click="moveItem('down',index)">
                                                        <v-icon>mdi-arrow-down</v-icon>
                                                    </v-btn>
                                                </v-list-item-icon>                                                 -->
                                                    <v-list-item  v-for="(value,index2) in valueRec" :key="'key'+index+index2" class="pa-2">
                                                        <InputField :inputName="index2" :inputProp="inputProp" :content.sync="valueList[index][index2]"></InputField>
                                                        <!-- <v-text-field 
                                                            :label="index2"
                                                            outlined 
                                                            v-model="valueList[index][index2]" :key="index2"
                                                        ></v-text-field> -->
                                                    </v-list-item>
                                            </v-list-group>
                                        </v-list>


                                </template>
                            </v-col>
                        </v-row>

                    </v-container>
                </v-form>

                </v-card>

            </v-col>
            <!--image-->
            <v-col cols="12" md="12">
                <v-toolbar dark color="panelSysInfo"><v-toolbar-title>System Info</v-toolbar-title>
                </v-toolbar>             
                <v-card class="mt-5">
                    <v-container class="py-0">
                        <v-row>
                            <v-col cols="12" md="12">
                                <v-text-field v-for="info in systemInfo" :key="info.alias" :value="form[info.name]" disabled :label="info.alias" outlined></v-text-field>
                            </v-col>
                        </v-row>

                    </v-container>

                </v-card>

                
            </v-col>

        </v-row>

    </v-container>  
</template>
    
<script>
import DlgMessage from '@/components/DlgMessage'
import InputField from '@/components/InputField'
import ApSettingService from "@/services/ApSettingService"
import Editor from "@/components/Editor.vue";


export default {
  components:{DlgMessage,Editor,InputField},
  props: {
       caller: String
    },
  data() {
    return{
            //breadcrumb
            items: [
              {text:'Settings',disabled: false,href:'/',},
              {text:'System Parameter',disabled: false,href:'/setttings',},
              {text:'Details',disabled: false,href:'#',},
              ],
            status_list:[],
            valueRec:[],
            valueList:[],
            routeParam:[],
            form:{login_id:null,sys_setting_id:0},
            systemInfo:[
                {"name":"created_date","alias":"Created Date"},
                {"name":"created_by","alias":"Created By"},
                {"name":"created_at","alias":"Created At"},
                {"name":"updated_date","alias":"Updated Date"},
                {"name":"updated_by","alias":"Updated By"},
                {"name":"updated_at","alias":"Updated At"},
            ],

            logo:'',
            inputProp:[],
            inputValue:[],

            inputRules: [
             v => !!v || 'This field is required'
            ],

            cpFiles:{
                file_type:'image',
                route_type:'merchants',
                showDialog:false,
            },
            dpicker:{menu1: false,menu2: false,},

    }
  },
  async created() {
    this.routeParam['sys_setting_id'] = this.$route.params.sys_setting_id;
    this.viewDetail();

  },
  
  methods:{

    async viewDetail(){
        this.form.sys_setting_id = this.routeParam.sys_setting_id
        try{
            ApSettingService.view_sys_setting(this.form).then((res) => {
                this.form = res.data.data;
                //console.log(this.form);
                for (const [key, value] of Object.entries(this.form)) {
                    if(value == null){
                        this.form[key] = "";
                    }
                }                
                //console.log(res.data);
                this.status_list = res.data.statusList; 
                this.valueList = this.form.value;
                this.inputProp = this.form.value_properties;
               
            }).catch((e)=>{
                //console.log(e.response);
                this.$refs.dlgMsg.showDlgBox(true,'error','View System Setting',e.response.data.error_message);
            })
            ;
        } catch(e) {
            //console.log(e);
            //this.$refs.dlgMsg.showDlgBox(true,'error','Supplier','Unknown Error');
        }
    },
    async save(){
        if(this.$refs.mainForm.validate()) {
            try{
                ApSettingService.update_sys_setting(this.form).then(() => {
                    this.$refs.dlgMsg.showDlgBox(true,'success','Update System Setting','Success.');
                }).catch((e)=>{
                    //console.log(e.response);
                    this.$refs.dlgMsg.showDlgBox(true,'error','Update System Setting',e.response.data.error_message);
                })
                ;
            } catch(e) {
                //console.log(e);
                //this.$refs.dlgMsg.showDlgBox(true,'error','Supplier','Unknown Error');
            }
        }
    },
    
    dlgClose(){
        this.visible = false;        
    },

    moveItem(direction,index){
        this.saveIndicator = "(*)"
        let tmpArray1 = [];
        let tmpArray2 = [];
        switch (direction) {
            case 'up':
                if(index==0)
                    return;
                tmpArray1 = this.valueList[index-1];
                tmpArray2 = this.valueList[index];
                this.$set(this.valueList,index-1,tmpArray2);
                this.$set(this.valueList,index,tmpArray1);
                break;
            case 'down':
                if(index==this.valueList.length-1)
                    return;
                tmpArray1 = this.valueList[index+1];
                tmpArray2 = this.valueList[index];
                this.$set(this.valueList,index+1,tmpArray2);
                this.$set(this.valueList,index,tmpArray1);
                break;       
            default:
                break;
        }
    }

  }
}
</script>